import React from "react";
import PageHero from "../../components/pagehero/PageHero";
import Icon from "../../components/icons/Icons";
import "./Jobs.css";

const jobs = [
  {
    title: "Software Engineer - Frontend/React",
    location: "Remote",
    url: "https://linkedin.com/company/tysonworks",
  },
  {
    title: "Jr. Sales Engineer - Software",
    location: "Remote",
    url: "https://linkedin.com/company/tysonworks",
  },
];

const Jobs = () => {
  return (
    <React.Fragment>
      <PageHero
        eyebrow="careers"
        title="Work with us"
        lede="We're a remote-first team of cloud experts. Join us in helping companies get the most out of AWS."
      />
      <section className="section-tight">
        <div className="container">
          <div className="jobs-list">
            {jobs.map((job) => (
              <a
                key={job.title}
                href={job.url}
                target="_blank"
                rel="noopener noreferrer"
                className="card card-hover job-row"
              >
                <span className="job-title">{job.title}</span>
                <span className="job-location">{job.location}</span>
                <span className="job-apply">
                  learn more
                  <Icon name="arrowUpRight" size={13} strokeWidth={2} />
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Jobs;
